export enum DocumentStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  InProgress = "Inprogress",
}
